import { render, staticRenderFns } from "./GrantAmount.vue?vue&type=template&id=dd4fad4e&scoped=true&"
import script from "./GrantAmount.vue?vue&type=script&lang=js&"
export * from "./GrantAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4fad4e",
  null
  
)

export default component.exports